<template>
    <b-container fluid class="mb-5">
        <b-row class="bgray-200 mb-5 py-4">
            <b-col cols="2">
                <b-button
                    variant="icon"
                    :to="{ name: 'TemplateList' }"
                    class="mb-2"
                    :disabled="is_loading_template"
                    small
                    >
                    &lang; <span class="pl-2">목록으로 이동</span>
                </b-button>
                <b-button
                    variant="icon"
                    :to="{ name: 'EditingTemplate', query: { value_new: false, template_id: $route.params.template_code } }"
                    :disabled="is_loading_template"
                    small
                    >
                    &lang; <span class="pl-2">편집 페이지로 이동</span>
                </b-button>
            </b-col>
            <b-col cols="6" offset-md="1" class="text-center">
                <div :class="['d-flex', 'flex-column justify-content-center align-items-center h-100']">
                    <div v-show="!is_loading_template">
                        <h3>{{ template_name }}</h3>
                        <h5 class="font-weight-normal ml-2 f-85">(type: {{ template_type }})</h5>
                    </div>
                    <b-spinner v-show="is_loading_template" style="width: 2.5rem; height: 2.5rem;" />
                </div>
                
            </b-col>
        </b-row>
        <b-row class="mb-3 mx-5">
            <b-col cols="12" md="6">
                <b-form-group label="번역상태 별 질문보기" label-class="h2" v-slot="{ ariaDescribedby }">
                    <b-form-checkbox-group
                        id="checkbox-group-view-translation-list"
                        v-model="conditionalView_selected"
                        :options="conditionalViewOption"
                        :aria-describedby="ariaDescribedby"
                        name="conditional-view-translation-list"
                        :disabled="questionTranslationGlobalDisabled"
                        />
                </b-form-group>
            </b-col>
            <b-col cols="12" md="4" offset-md="2" class="text-right pr-0">
                <b-form-input
                    class="mb-3"
                    placeholder="제목, 질문코드 입력 후 엔터를 쳐주세요"
                    v-model="search_question"
                    @keyup.enter="searchByQuestionName"
                    :disabled="questionTranslationGlobalDisabled"
                    />
                <b-btn
                    class="mr-2"
                    variant="info"
                    @click="initializeQuestionAllTranslation"
                    :disabled="questionTranslationGlobalDisabled"
                    >
                    번역 일괄 초기화

                    <span v-show="total_initialize_progress !== false">
                        ({{ total_initialize_progress }} %)
                    </span>
                </b-btn>
                <b-btn
                    v-if="total_initialize_progress !== false"
                    class="mr-2"
                    variant="danger"
                    :disabled="is_cancel_bulk_initialize"
                    @click="is_cancel_bulk_initialize = true"
                    >
                    중단
                </b-btn>
                <b-btn
                    @click="is_collapsed_full_list = !is_collapsed_full_list"
                    :disabled="questionTranslationGlobalDisabled"
                    >
                    전체 {{ is_collapsed_full_list ? '펼쳐보기' : '접기' }}
                </b-btn>
            </b-col>
        </b-row>
        <b-row v-if="load_error" class="mx-5 mb-3">
            <b-col cols="12">
                <PageEmptyComponent :error="load_error" @retry="readTemplate" />
            </b-col>
        </b-row>
        <b-row v-show="is_loading_template" class="py-5 mx-5 mb-3 bgray-300">
            <b-col cols="12" class="h-100">
                <div class="d-flex align-items-center justify-content-center h-100">
                    <span class="h5 mr-3 mb-0">불러오는중</span>
                    <b-spinner style="width: 2rem;height: 2rem;" />
                </div>
            </b-col>
        </b-row>
        <b-row v-show="!is_loading_template" class="mb-3 mx-5">
            <b-col cols="12">
                <question-translation-row
                    v-for="(template, template_idx) in template_contents"
                    :key="`question-${template.question_code}-question-translation-group-${template_idx}`"
                    v-show="rowVisibility[template_idx]"
                    :template="template"
                    :template-idx="template_idx"
                    :immutable="template_contents_immutable[template_idx]"
                    :disabled="questionTranslationGlobalDisabled"
                    @initialize="initalizeQuestionTranslation"
                    @save="saveEditedQuestion"
                    @toggle-edit="showEditForm"
                    @toggle-collapse="collapseEditForm"
                    @edit="editQuestionInfo"
                    />
            </b-col>
        </b-row>
        <b-row class="mx-5">
            <b-col cols="12" class="text-right pr-0">
                <b-btn
                    class="mr-2"
                    variant="info"
                    @click="initializeQuestionAllTranslation"
                    :disabled="questionTranslationGlobalDisabled"
                    size="sm"
                    >
                    번역 일괄 초기화

                    <span v-show="total_initialize_progress !== false">
                        ({{ total_initialize_progress }} %)
                    </span>
                </b-btn>
                <b-btn
                    @click="is_collapsed_full_list = !is_collapsed_full_list"
                    :disabled="questionTranslationGlobalDisabled"
                    size="sm"
                    >
                    전체 {{ is_collapsed_full_list ? '펼쳐보기' : '접기' }}
                </b-btn>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash';
import FuzzySearch from 'fuzzy-search';

import QuestionTranslationRow from '@shared/components/admin/pages/_EditingTemplateTranslation/QuestionTranslationRow.vue';
import PageEmptyComponent from '@shared/components/admin/components/common/PageEmptyComponent.vue';
import unsavedChangesGuard from '@shared/mixin/unsaved-changes-guard';
import { getErrorMessage } from '@core/utils/api/errorMessage';

export default {
    name: 'editing-template-translation',
    mixins: [unsavedChangesGuard],
    components: { QuestionTranslationRow, PageEmptyComponent },
    data () {
        return {
            is_loading_template: true,
            load_error: '',
            is_cancel_bulk_initialize: false,
            is_saving_template: false,
            template_name: null,
            template_contents: null,
            template_contents_immutable: null,
            template_code: null,
            template_scoring: null,
            template_type: null,
            question_codes: null,
            conditionalView_selected: [
                'need_name_kr',
                'need_infobox_kr',
                'need_name_translation',
                'need_infobox_translation'
            ],
            conditionalViewOption: [
                { text: '제목 미입력', value: 'need_name_kr'},
                { text: '제목 번역 미입력', value: 'need_name_translation'},
                { text: '배경정보 미입력', value: 'need_infobox_kr'},
                { text: '배경정보 번역 미입력', value: 'need_infobox_translation'},
            ],
            is_collapsed_full_list: true,
            search_question: null,
            is_search_question: false,
            total_initialize_progress: false
        }
    },
    computed: {
        ...mapState(['user_id', 'company_id']),
        questionTranslationGlobalDisabled () {
            return  this.is_loading_template || this.is_saving_template || this.total_initialize_progress !== false || !!this.load_error
        },
        hasUnsavedChanges () {
            return !!this.template_contents && this.template_contents.some(_template => _template.edited)
        },
        // 행별 표시 여부를 미리 계산해 둔다.
        // 템플릿 바인딩에서 showQuestionbarBySelectedState(template) 를 직접 호출하면
        // 렌더마다 모든 행에 대해 배열 생성 + some/includes 순회가 재실행된다.
        // 입력 한 글자마다 이 비용이 행 수만큼 반복돼 타이핑이 지연됐다.
        rowVisibility () {
            if (!this.template_contents) return []

            return this.template_contents.map(_template => {
                const _matches_filter = this.showQuestionbarBySelectedState(_template)
                return this.is_search_question
                    ? _template.searched === true && _matches_filter
                    : _matches_filter
            })
        }
    },
    watch: {
        is_collapsed_full_list (_collapsed_status) {
            this.template_contents.forEach(content => {
                content.collapsed = _collapsed_status
            });
        }
    },
    async created () {
        await this.readTemplate()
    },
    methods: {
        async readTemplate () {
            try {
                this.is_loading_template = true
                this.load_error = ''
                const response = await this.$axios.get('/read_template', {
                    params: { template_code: this.$route.params.template_code }
                })

                let _template_contents = JSON.parse(response.data.template_contents)
                _template_contents = this.flattenTemplateContents([ ..._template_contents ])
        
                const _question_codes = _template_contents.map(({ question_code }) => question_code)
                const _questionsInfo = await this.readQuestionsInfo(_question_codes)
                _template_contents = this.mergeTemplateWithTranslation(_template_contents, _questionsInfo)
                const _template_contents_immutable = JSON.stringify([ ..._template_contents ])
                this.template_contents_immutable = Object.freeze(JSON.parse(_template_contents_immutable))
                this.template_contents = _template_contents
                this.question_codes = _question_codes

                this.template_name = response.data.template_name
                this.template_code = response.data.template_code
                this.template_scoring = response.data.template_scoring
                this.template_type = response.data.template_type
            } catch (error) {
                console.log(` ~ error => `, error);
                if (!(await this.handleUnauthorized(error))) {
                    this.load_error = `질문지를 불러오지 못했습니다. (코드: ${this.$route.params.template_code}, 사유: ${getErrorMessage(error, error && error.message ? error.message : '알 수 없는 오류')})`
                }
            } finally {
                this.$nextTick(() => {
                    this.is_loading_template = false
                })
            }
        },
        /** 401 이면 로그아웃 처리하고 true */
        async handleUnauthorized (error) {
            if (error && error.response && error.response.status === 401) {
                alert(this.$t(`다중 로그인 등 권한 오류가 발생했습니다. 다시 로그인해 주십시오.`))
                await this.$store.dispatch('logout')
                this.$router.push({name:'Login'})
                return true
            }
            return false
        },
        flattenTemplateContents (templates, parent_question_id = null, level = 0) {
            return templates.reduce((_template_codes, _template) => {
                const {
                    question_name, question_name_e, question_name_c,
                    question_infobox, question_infobox_e, question_infobox_c,
                    question_code, children
                } = _template

                _template_codes.push({
                    question_name, question_name_e, question_name_c,
                    question_infobox, question_infobox_e, question_infobox_c,
                    question_code,
                    parent_question_id,
                    level,
                    collapsed: true,
                    edited: false,
                    show_info: true,
                    searched: false
                })
                
                if (children.length) {
                    const _flatten_child_template = this.flattenTemplateContents(children, question_code, level + 1)
                    _template_codes.push(..._flatten_child_template)
                }
                return _template_codes
            }, [])
        },
        async readQuestionsInfo (question_codes) {
            {
                if (question_codes.length) {
                    const _request_question_codes = question_codes.reduce((_request_promises, _question_code) => {
                            _request_promises.push(this.$axios.get('/read_question', { params: { question_code: _question_code } }))
                        return _request_promises
                    }, [])

                    const _res_request_question_info = await Promise.all(_request_question_codes)
                    
                    return _res_request_question_info.reduce((_questions_info, { data }) => {
                        const { question_name, question_name_e, question_name_c,
                            question_infobox, question_infobox_e, question_infobox_c,
                            question_code ,template_code
                        } = data

                        _questions_info.push({                            
                            question_name: this.isValueEmpty(question_name) ? null : question_name,
                            question_name_e: this.isValueEmpty(question_name_e) ? null : question_name_e,
                            question_name_c: this.isValueEmpty(question_name_c) ? null : question_name_c,
                            question_infobox: this.isValueEmpty(question_infobox) ? null : question_infobox,
                            question_infobox_e: this.isValueEmpty(question_infobox_e) ? null : question_infobox_e,
                            question_infobox_c: this.isValueEmpty(question_infobox_c) ? null : question_infobox_c,
                            need_name_kr: this.isValueEmpty(question_name),
                            need_infobox_kr: this.isValueEmpty(question_infobox),
                            need_name_translation: this.isValueEmpty(question_name_e) || this.isValueEmpty(question_name_c),
                            need_infobox_translation: this.isValueEmpty(question_infobox_e) || this.isValueEmpty(question_infobox_c),
                            question_code, template_code
                        })

                        return _questions_info
                    }, [])
                } else {
                    return []
                }
            }
        },
        mergeTemplateWithTranslation (templates, templatesInfo) {
            return templates.reduce((_templates, _template, _template_idx) => {
                const _question_translaton = templatesInfo.find(({ question_code }) => question_code === _template.question_code)
                if (_question_translaton) {
                    _templates[_template_idx] = { ..._template, ..._question_translaton }
                } else {
                    _templates[_template_idx] = {
                        ..._template,
                        question_name_e: null, question_name_c: null,
                        question_infobox_e: null, question_infobox_c: null
                    }
                }
                
                return _templates
            }, templates)
        },
        showEditForm (template_idx) {
            this.template_contents[template_idx].show_info = !this.template_contents[template_idx].show_info
        },
        collapseEditForm (template_idx) {
            this.template_contents[template_idx].collapsed = !this.template_contents[template_idx].collapsed
        },
        // 4개 입력 칸 전부를 원본과 비교한다(마지막으로 만진 칸만 비교하면 다른 칸의 미저장 변경을 놓친다)
        editQuestionInfo (question_idx) {
            this.$nextTick(() => {
                const _current = this.template_contents[question_idx]
                const _origin = this.template_contents_immutable[question_idx]
                if (!_current || !_origin) return
                _current.edited = ['question_name_e', 'question_name_c', 'question_infobox_e', 'question_infobox_c']
                    .some(_field => (_current[_field] || '') !== (_origin[_field] || ''))
            })
        },
        async saveEditedQuestion (question_idx) {
            try {
                this.is_saving_template = true
                const {
                    question_code,
                    question_name_e, question_name_c,
                    question_infobox_e, question_infobox_c
                } = this.template_contents[question_idx]

                // 번역수정 버전 저장
                const formData = new FormData()
                if (!this.isValueEmpty(question_name_e)) formData.append('question_name_e', question_name_e)
                if (!this.isValueEmpty(question_name_c)) formData.append('question_name_c', question_name_c)
                if (!this.isValueEmpty(question_infobox_e)) formData.append('question_infobox_e', question_infobox_e)
                if (!this.isValueEmpty(question_infobox_c)) formData.append('question_infobox_c', question_infobox_c)

                const _res_update_question = await this.$axios.post(`/translate/question/${question_code}`, formData)

                // 번역 수정한 template_contents 업데이트
                this.template_contents[question_idx] = {
                    ...this.template_contents[question_idx],
                    ..._res_update_question.data
                }
                
                // 업데이트 템플릿 컨텐츠
                await this.updateTemplateContents(question_idx)
                this.$EventBus.$emit('toast-success', '성공', `번역을 저장하였습니다. (${question_code})`)
            } catch (error) {
                console.log(` ~ error => `, error);
                if (!(await this.handleUnauthorized(error))) {
                    // 입력한 내용(edited 상태)은 그대로 두고 재시도할 수 있게 한다
                    this.$EventBus.$emit('toast-failure', '번역 저장 실패', getErrorMessage(error, error && error.message ? error.message : '저장하지 못했습니다. 다시 시도해주세요.'))
                }
            } finally {
                this.is_saving_template = false
            }
        },
        async initializeQuestionAllTranslation () {
            const _total = this.template_contents.length
            if (!_total) return

            const _ok = await this.$showModal({
                type: 'confirm',
                state: 'error',
                title: '번역 일괄 초기화',
                message: `질문 ${_total}개의 영문/중문 제목·배경정보가 초기화됩니다(수동으로 교정한 번역과 저장하지 않은 편집 포함). 되돌릴 수 없습니다. 진행 중에는 '중단'으로 멈출 수 있습니다.`
            })
            if (!_ok) return

            this.total_initialize_progress = 0
            this.is_cancel_bulk_initialize = false
            let _done = 0
            const _failed_codes = []
            try {
                for (const [_template_index, _template_content] of this.template_contents.entries()) {
                    if (this.is_cancel_bulk_initialize) break
                    try {
                        await this.requestInitializeQuestion(_template_index, _template_content.question_code)
                    } catch (error) {
                        if (await this.handleUnauthorized(error)) return
                        _failed_codes.push(_template_content.question_code)
                    }
                    _done++
                    this.total_initialize_progress = Math.floor((_done / _total) * 100)
                }

                // 템플릿 저장은 루프가 끝난 뒤 한 번만
                if (_done > _failed_codes.length) {
                    await this.updateTemplateContents(null)
                }

                const _summary = `${_done - _failed_codes.length}개 초기화${_failed_codes.length ? `, ${_failed_codes.length}개 실패(${_failed_codes.slice(0, 5).join(', ')}${_failed_codes.length > 5 ? ' 외' : ''})` : ''}${this.is_cancel_bulk_initialize ? ' (중단됨)' : ''}`
                this.$EventBus.$emit(_failed_codes.length ? 'toast-warning' : 'toast-success', '번역 일괄 초기화', _summary)
            } catch (error) {
                this.$EventBus.$emit('toast-failure', '번역 일괄 초기화 실패', getErrorMessage(error, error && error.message ? error.message : '템플릿을 저장하지 못했습니다.'))
            } finally {
                this.total_initialize_progress = false
                this.is_cancel_bulk_initialize = false
            }
        },
        // 서버 초기화 + 화면 반영만 한다(템플릿 저장은 호출한 쪽에서)
        async requestInitializeQuestion (question_idx, question_code) {
            let _initial_target_formData = new FormData()
            _initial_target_formData.append('question_name', null)
            _initial_target_formData.append('question_infobox', null)

            const _res_initialized_question = await this.$axios.post(`/translate/initial/question/${question_code}`, _initial_target_formData)
            const _initialized_question = _res_initialized_question.data

            this.template_contents[question_idx].question_name_e = _initialized_question.question_name_e
            this.template_contents[question_idx].question_name_c = _initialized_question.question_name_c
            this.template_contents[question_idx].question_infobox_e = _initialized_question.question_infobox_e
            this.template_contents[question_idx].question_infobox_c = _initialized_question.question_infobox_c
        },
        async initalizeQuestionTranslation (question_idx, question_code) {
            try {
                this.is_saving_template = true
                await this.requestInitializeQuestion(question_idx, question_code)

                // 업데이트 템플릿 컨텐츠
                await this.updateTemplateContents(question_idx)
                this.$EventBus.$emit('toast-success', '성공', `번역을 초기화하였습니다. (${question_code})`)
            } catch (error) {
                console.log(` ~ error => `, error);
                if (!(await this.handleUnauthorized(error))) {
                    this.$EventBus.$emit('toast-failure', '번역 초기화 실패', getErrorMessage(error, error && error.message ? error.message : '초기화하지 못했습니다. 다시 시도해주세요.'))
                }
            } finally {
                this.is_saving_template = false
            }
        },
        async updateTemplateContents (question_idx) {
            // template의 template_contents 업데이트 하기 위한 평면화된 template_contents를 계층화 구조로 변환
            const _nested_data_contents = this.generateNestedTemplateContents(this.template_contents)

            // 업데이트된 계층 구조의 template_contents 저장
            const _formData = new FormData()
            _formData.append('user_id', this.user_id)
            _formData.append('template_name', this.template_name)
            _formData.append('template_code', this.template_code)
            _formData.append('template_scoring', this.template_scoring)
            _formData.append('template_type', this.template_type)
            _formData.append('template_contents', JSON.stringify(_nested_data_contents))

            const _res_updated_template = await this.$axios.post('/save_template', _formData)

            // db에 저장된 data로 관련 state 갱신
            this.template_code = _res_updated_template.data.template_code
            this.template_scoring = _res_updated_template.data.template_scoring
            this.template_type = _res_updated_template.data.template_type

            // 저장된 template_contents 평면화 구조로 전환 및 question_codes 업데이트
            const _updated_template_contents = JSON.parse(_res_updated_template.data.template_contents)
            let _updated_flatten_template = this.flattenTemplateContents(_updated_template_contents)
            _updated_flatten_template = _updated_flatten_template.map(_template => ({
                ..._template,
                need_name_kr: this.isValueEmpty(_template.question_name),
                need_infobox_kr: this.isValueEmpty(_template.question_infobox),
                need_name_translation: this.isValueEmpty(_template.question_name_e) || this.isValueEmpty(_template.question_name_c),
                need_infobox_translation: this.isValueEmpty(_template.question_infobox_e) || this.isValueEmpty(_template.question_infobox_c),
            }))

            // immutable_template_contents 및 편집한 template_content 업데이트
            const _template_contents_immutable = JSON.stringify([ ..._updated_flatten_template ])
            this.template_contents_immutable = Object.freeze(JSON.parse(_template_contents_immutable))

            this.question_codes = _updated_flatten_template.map(({ question_code }) => question_code)
            if (question_idx === null) {
                this.template_contents = _updated_flatten_template
            } else {
                this.$set(this.template_contents, question_idx, _updated_flatten_template[question_idx])
            }
        },
        generateNestedTemplateContents (templateContents, _question_code = null) {
            const filtered = templateContents.filter(item => {
                return item.parent_question_id === _question_code
            })

            const filteredMap = filtered.map(_child => {
                const {
                    question_name, question_name_e, question_name_c,
                    question_infobox, question_infobox_e, question_infobox_c,
                    question_code
                } = _child

                const _nested_parent = {
                    question_name: this.isValueEmpty(question_name) ? null : question_name,
                    question_name_e: this.isValueEmpty(question_name_e) ? null : question_name_e,
                    question_name_c: this.isValueEmpty(question_name_c) ? null : question_name_c,
                    question_infobox: this.isValueEmpty(question_infobox) ? null : question_infobox,
                    question_infobox_e: this.isValueEmpty(question_infobox_e) ? null : question_infobox_e,
                    question_infobox_c: this.isValueEmpty(question_infobox_c) ? null : question_infobox_c,
                    question_code,
                    children: this.generateNestedTemplateContents(templateContents, question_code)
                }

                return _nested_parent
            });
            
            return filteredMap
        },
        showQuestionbarBySelectedState ({ need_name_kr, need_name_translation, need_infobox_kr, need_infobox_translation }) {
            const _show_status = []
            if (need_name_kr) _show_status.push('need_name_kr')
            if (need_name_translation) _show_status.push('need_name_translation')
            if (need_infobox_kr) _show_status.push('need_infobox_kr')
            if (need_infobox_translation) _show_status.push('need_infobox_translation')

            if (!_show_status.length) {
                return false
            } else {
                return _show_status.some(_status => this.conditionalView_selected.includes(_status))
            }
        },
        searchByQuestionName () {
            if (this.isValueEmpty(this.search_question)) {
                this.template_contents.forEach(element => {
                    element.searched = null
                })
                this.is_search_question = false
            } else {
                const searcher = new FuzzySearch(this.template_contents,
                    ['question_code', 'question_name', 'question_infobox', 'question_name_e', 'question_infobox_e', 'question_name_c', 'question_infobox_c'],
                    { caseSensitive: true }
                );

                const result = searcher.search(this.search_question);
                result.forEach(element => {
                    element.searched = true
                });
                this.is_search_question = true
            }
        },
        titleMarginClasses (nestedLevel) {
            return [ 'node-level', `node-level-${nestedLevel}`, 'rounded' ]
        },
        isValueEmpty (val) {
            return !val || val.trim() === ''
        }
    }
}
</script>

<style lang="scss" scoped>

// 행 내부 스타일(-title / -body / -level-* 등)은 QuestionTranslationRow.vue 로 옮겼다.
// scoped 스타일은 자식 컴포넌트의 **루트 요소**에만 부모 scope id 가 붙으므로,
// 여기 남겨두면 자식 내부 요소에는 적용되지 않는다.
// 아래 형제 마진은 행끼리의 관계라 부모가 소유한다 (루트에는 적용됨).
.questionBar {
    & + .questionBar {
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
    }
}

</style>
